/* Returns a mapped string if it exists in the dict, otherwise returns the original string.
   mapDict('a', {a:'hello'}) == 'hello'
   mapDict('b', {a:'hello'}) == 'b'
 */
export var mapDict = function mapDict(val, dict) {
  return val in dict ? dict[val] : val;
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@rosetta/redux-utils/es/stringutils.js
// module id = 611
// module chunks = 0